/**
 * Post Order Details InfoCard Component
 */

// React
import React, { useState, useEffect, useContext } from "react";

// Context
import AuthContext from "../../authContext";

//UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import JalaliUtils from "@date-io/jalaali";
import { Controller, useForm } from "react-hook-form";

import {
  Grid,
  Button,
  Divider,
  TextField,
  FormHelperText,
  MenuItem,
  Checkbox,
} from "@material-ui/core";

// Components
import Can from "../../components/Can";

// Router
import { Link, useHistory } from "react-router-dom";

// Helper
import {
  translate,
  formaterPhoneNumber,
  packegeCounter,
  disablePrevDateByHour,
  convertPersianDigit2English,
  checkHourisPast,
  removeEmptyValueObject,
  numberWithCommas,
  fixNumbers,
} from "../../utils/helpers";
import jMoment from "moment-jalaali";
import handleNotfication from "../../utils/handleNotfication";
import { isEmpty } from "lodash";

// Type
import {
  DatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import { Card } from "@material-ui/core";
import handleError from "../../utils/handleError";
import ordersRepository from "client-sdk/src/Repository/orders-repository";
import { UpdateOrderDeliveryCost } from "client-sdk/src/orders/orders";
import { Client } from "client-sdk/src";

import { convertDatePersianToEnglish } from "../../utils/helpers";
import { useCutoffHandler } from "../../utils/hook/useGetCutoffList";
import getAllByDeliveryService from "client-sdk/src/orders/getAllByDeliveryService";
import moment from "moment";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    textInput: {
      color: "#8a8a8a",
      "& input, .MuiSelect-root": {
        padding: "6px 0 12px !important",
      },

      "& .MuiInput-underline::before": {
        borderBottom: "1px solid #d8d8d8 !important",
      },
    },
    paper: {
      marginTop: "36px",
      marginBottom: "36px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
      "@media (max-width: 768px)": {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      marginBottom: "8px",
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: "scale(-1, 1)",
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 600,
      // color: '#8A8A8A',
      marginRight: "10px",
      flex: 0.5,
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    submitbtn: {
      border: "none",
      backgroundColor: "#DFA01F",
      padding: "8px",
      color: "#fff",
      borderRadius: "5px",
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#c9911e",
      },
      width: "100%",
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      marginBottom: "14px",
      overflow: "visible !important",
      padding: "14px",
      paddingBottom: "0",
      "@media (max-width: 768px)": {
        overflow: "auto",
      },
    },
    contentBox: {
      marginTop: "-1px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "14px",
      fontWeight: 500,
      textAlign: "right",
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: "10px",
      fontWeight: 400,
    },

    missingOppositeContent: {
      "&::before": {
        flex: "none",
      },
    },
    paperHistory: {
      alignItems: "center",
    },
  })
);

const token = localStorage.getItem("token") || "";
export function InfoCard(props: any) {
  const authContext = useContext(AuthContext);
  const [editMode, setEditMode] = useState(false as boolean);
  const [orderDeliveryCost, setOrderDeliveryCost] = useState<number>();
  const [deliveryCost, setDeliveryCost] = useState<number>();
  const [deliverInRonad, setDeliverInRonad] = useState<boolean>(false);

  const [dateInDatePiker, setDateInDatePiker] = useState<any>("");
  const [couriersList, setCouriersList] = useState<any>([]);
  const [deliveryTime, setDeliveryTime] = useState<any>("");
  const [stateFillmentTypes, setStateFillmentTypes] = useState<any>([]);
  const [enableCost, setEnableCost] = useState(false);

  const classes = useStyles();
  const history = useHistory();

  const {
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
    register,
    control,
    reset,
  } = useForm({
    defaultValues: {
      orderType: props.order.orderType,
      deliveryDate: "",
      // deliveryTime: '',
      deliveryServiceId: "",
      fulfillmentTypeId: "",
      courierId: "",
      cutoffId: "",
      deliveryStartTime: props.order.deliveryStartTime,
      deliveryEndTime: props.order.deliveryEndTime,
      origin: "",
      destination: "",
      customerName: "",
      customerNationalCode: "",
      customerMobileNumber: "",
      customerPhoneNumber: "",
      customerProvince: "",
      customerCity: "",
      customerZipCode: props.order.customerZipCode,
      deliveryType: "",
      customerAddress: "",
    },
  });

  const [orderType, setOrderType] = useState<null | string>(
    props.order.orderType
  );
  const [deliveryTypeValue, setDeliveryTypeValue] = useState<null | string>(
    watch("deliveryType")
  );
  const values = getValues();

  function toEnglishDigits(str) {
    var e = "۰".charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function (t) {
      return t.charCodeAt(0) - e;
    });

    e = "٠".charCodeAt(0);
    str = str.replace(/[٠-٩]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
    return str;
  }
  const isFromCenter = props.order.orderType === "FROM_CENTER";
  const fulfillmentTypeId = watch("fulfillmentTypeId");
  const courierId = watch("courierId");
  const deliveryServiceId = watch("deliveryServiceId");
  const deliveryDate = watch("deliveryDate");
  const cutoffId = watch("cutoffId");

  const formattedDateSelected = moment(deliveryDate).format("YYYY-MM-DD");
  const dateSelected = convertDatePersianToEnglish(formattedDateSelected);

  const { listCutoff } = useCutoffHandler({
    courierId,
    dateSelected: dateSelected,
    forceToFind: true,
    fulfillmentTypeId,
    setDateInDatePiker,
    setValue,
  });

  useEffect(() => {
    if (!isEmpty(props.order)) {
      const {
        orderType,
        deliveryDate,
        deliveryStartTime,
        deliveryEndTime,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerMobileNumber,
        customerProvince,
        customerZipCode,
        trackingCode,
        description,
        fulfillmentWarehouseId,
        centerId,

        deliveryServiceId,
        fulfillmentTypeId,
        courierId,
        cutoffId,

        customerLat,
        customerLon,
      } = props.order;
      const payload = {
        orderType,
        deliveryDate,

        deliveryServiceId,
        fulfillmentTypeId,
        courierId,
        cutoffId,

        deliveryStartTime: deliveryDate + " " + deliveryStartTime,
        deliveryEndTime: deliveryDate + " " + deliveryEndTime,
        // deliveryTime:
        //   deliveryStartTime === '11:00:00'
        //     ? '11-15'
        //     : deliveryStartTime === '16:00:00'
        //       ? '16-20'
        //       : '',
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        customerMobileNumber,
        customerZipCode,
        trackingCode,
        description,
        origin: orderType === "FROM_CENTER" ? centerId : fulfillmentWarehouseId,
        destination: orderType === "TO_CENTER" ? centerId : null,
      };
      reset(payload);
      setDeliverInRonad(props.order.deliveryLocationType === "IN_RONAD");
    }
  }, [props.order]);

  useEffect(() => {
    if (
      values.deliveryDate &&
      checkHourisPast(
        Number(values.deliveryTime?.substring(0, 2)),
        values.deliveryDate
      )
    )
      setValue("deliveryTime", "");
  }, [values.deliveryDate]);

  const handleChangeDeliveryCost = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOrderDeliveryCost(+e.target?.value);
  };

  const handleChangeDeliverInRonad = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDeliverInRonad(event.target.checked);
  };

  const submitOrderDeliveryCost = async () => {
    try {
      const makeRequest = new UpdateOrderDeliveryCost()
        .id(props.order.id)
        .data(orderDeliveryCost)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication("هزینه ارسال با موفقیت ثبت شد", "success");
      setDeliveryCost(orderDeliveryCost);
      setOrderDeliveryCost("");
    } catch (err) {
      handleNotfication(
        "تغییر کد پیگیری پست ثبت نشد دوباره تلاش کنید",
        "error"
      );
    }
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      "deliveryDate",
      convertPersianDigit2English(date.format("YYYY-MM-DD"))
    );
    setValue("deliveryTime", "");
  };

  const handleDisableTime = (hour: number) => {
    return (
      checkHourisPast(hour, values.deliveryDate) &&
      props.order.deliveryTypeValue !== "VIP"
    );
  };

  const handleUpdateOrders = (data: any) => {
    const {
      customerAddress,
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode,
      customerProvince,
      customerZipCode,
      deliveryDate: deliver,
      // deliveryTime,
    } = data;

    const customerInfo = {
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode,
      customerPhoneNumber: props.order.customerPhoneNumber,
      customerProvince,
      customerZipCode,
      customerLat: "",
      customerLon: "",
      customerAddress,
      deliveryType: props.order.deliveryType,
      partnerId: props.order.partnerId,
      orderType: props.order.orderType,
      codPaymentCode: props.order.codPaymentCode,
      codValue: props.order.codValue,
      paymentType: props.order.paymentType,
    };
    if (deliver.date) {
      var deliveryDate = convertPersianDigit2English(
        deliver.format("YYYY-MM-DD")
      );
    } else {
      var deliveryDate = deliver;
    }
    const payload = {
      deliveryType: props.order.deliveryType,
      deliveryDate,
      centerId: props.order.centerId,
      fulfillmentTypeId,
      courierId,
      deliveryServiceId,
      cutoffId,
      deliveryStartTime: convertPersianDigit2English(
        deliveryTime.substring(0, 2).concat(":00:00")
      ),
      deliveryEndTime: convertPersianDigit2English(
        deliveryTime.substring(3, 5).concat(":00:00")
      ),
      id: props.order.id,
      fulfillmentWarehouseId: props.order.fulfillmentWarehouseId,
      deliveryLocationType: deliverInRonad ? "IN_RONAD" : "IN_CUSTOMER_ADDRESS",
    };
    if (!isFromCenter) {
      delete payload.centerId;
    }

    const body = {
      ...removeEmptyValueObject(payload),
      ...removeEmptyValueObject(customerInfo),
    };

    body.receiptFile = "";
    body.labelFile = "";
    body.customerZipCode = fixNumbers(body.customerZipCode);

    ordersRepository
      .updateOrder({ payload: { body } })
      .then((res) => {
        handleNotfication("سفارش با موفقیت ویرایش شد", "success");
        setEditMode(false);
        history.go(0);
      })
      .catch((err) => handleError(err.response));
  };

  useEffect(() => {
    if (deliveryServiceId) {
      const handlerGetAllByDeliveryService = async () => {
        try {
          const { res, ok } = await getAllByDeliveryService(
            props.order.deliveryServiceId,
            isFromCenter
          );
          if (ok) setStateFillmentTypes(res);
        } catch (error) {
          handleError(error);
        }
      };
      handlerGetAllByDeliveryService();
    }
  }, [deliveryServiceId]);

  useEffect(() => {
    if (stateFillmentTypes.length > 0) {
      const res = stateFillmentTypes.find(
        (item: any) => item.id === fulfillmentTypeId
      );
      setCouriersList(res?.courierLogisticDTOS);
    }
  }, [fulfillmentTypeId, stateFillmentTypes]);

  useEffect(() => {
    if (couriersList?.length > 0) {
      const res = couriersList.find((item: any) => item.id === courierId);
      setEnableCost(!res?.enableCost);
    }
  }, [couriersList, courierId]);

  useEffect(() => {
    setValue("cutoffId", "");
  }, [courierId, fulfillmentTypeId]);

  useEffect(() => {
    setValue("courierId", "");
  }, [fulfillmentTypeId]);

  useEffect(() => {
    if (listCutoff.length > 0) {
      const res = listCutoff.find((item: any) => item.id === cutoffId);
      setDeliveryTime(res?.value);
    }
  }, [listCutoff, cutoffId, editMode]);

  return (
    <Grid item lg={3} md={3} sm={12} xs={12}>
      <form onSubmit={handleSubmit(handleUpdateOrders)}>
        <Card className={classes.card}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نام شرکت:  "}</span>

                <span style={{ flex: 1 }}>{props.order?.partnerName}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد پیگیری:  "}</span>

                <span style={{ flex: 1 }}>{props.order?.trackingCode} </span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع ارسال:  "}</span>
                <span style={{ flex: 1 }}>
                  {translate(props.order?.deliveryType)}
                </span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"مبدا:  "}</span>

                <span style={{ flex: 1 }}>
                  {props.order?.fulfillmentWarehouseName
                    ? props.order?.fulfillmentWarehouseName
                    : props.order?.centerName}
                </span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"تعداد آیتم:  "}</span>
                <span style={{ flex: 1 }}>{props.order?.items?.length}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"تعداد بسته:  "}</span>
                <span style={{ flex: 1 }}>
                  {props.order?.orderPackages &&
                    packegeCounter(props.order?.orderPackages)}
                </span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع پرداخت:  "}</span>
                <span style={{ flex: 1 }}>
                  {translate(props.order.paymentType, "cod")}
                </span>
              </div>
            </Grid>

            {props.order.paymentType === "COD" && (
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"مبلغ:  "}</span>
                  <span dir="ltr">{props.order.codValue}</span>
                </div>
              </Grid>
            )}
            <Divider className={classes.divider} />
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                {/* <span className={classes.label}>
                    {'هزینه ارسال(ریال):'}
                </span> */}
                <Can
                  role={authContext.user.role}
                  perform="orders:post-tracking-code"
                  yes={() => (
                    <div>
                      <TextField
                        id="outlined-basic"
                        value={orderDeliveryCost}
                        onChange={handleChangeDeliveryCost}
                        size={"small"}
                        disabled={enableCost}
                        variant="outlined"
                        placeholder="هزینه ارسال(ریال):"
                        // fullWidth
                      />
                      <Button
                        style={{ marginRight: "5px", height: "100%" }}
                        variant="contained"
                        disabled={enableCost}
                        color="secondary"
                        onClick={submitOrderDeliveryCost}
                        size={"medium"}>{`ثبت`}</Button>
                    </div>
                  )}
                  no={() => <span>{props.order?.deliveryCost}</span>}
                />
              </div>
              {deliveryCost
                ? numberWithCommas(deliveryCost)
                : numberWithCommas(props?.order?.deliveryCost)}
            </Grid>
            <Divider className={classes.divider} />
            {props.order.orderValue && (
              <>
                <Grid item xs={12} sm={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>{"ارزش سفارش"}</span>
                    <span style={{ flex: 1 }} dir="rtl">
                      {props.order.orderValue.toLocaleString()} ریال
                    </span>
                  </div>
                </Grid>
                <Divider className={classes.divider} />
              </>
            )}
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع پردازش:"}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div
                        style={{ width: "100%" }}
                        data-cy="fulfillmentTypeId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="fulfillmentTypeId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              disabled={!editMode}
                              error={
                                !!errors.fulfillmentTypeId &&
                                !!errors.fulfillmentTypeId
                              }>
                              {stateFillmentTypes?.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.fulfillmentTypeId &&
                            " بازه خدمات تحویل الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.fulfillmentTypeName}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"خدمات تحویل:"}</span>
                <span style={{ flex: 1 }}>
                  {props.order.deliveryServiceName}
                </span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نوع ناوگان:"}</span>
                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div style={{ width: "100%" }} data-cy="courierId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="courierId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              disabled={!editMode}
                              error={!!errors.courierId && !!errors.courierId}>
                              {couriersList?.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.courierId &&
                            " بازه نوع ناوگان الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>{props.order.courierName}</span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"تاریخ تحویل:  "}</span>

                {editMode ? (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <Controller
                      rules={{ required: true }}
                      name="deliveryDate"
                      control={control}
                      as={
                        <DatePicker
                          id="deliveryDate"
                          name="deliveryDate"
                          format="jYYYY/jMM/jDD"
                          okLabel="تأیید"
                          cancelLabel="لغو"
                          defaultValue={props.order.deliveryDate}
                          value={values.deliveryDate}
                          onChange={handleDeliveryDateChange}
                          error={errors.hasOwnProperty("deliveryDate")}
                          helperText={
                            errors.deliveryDate && errors.deliveryDate.message
                          }
                        />
                      }
                    />
                    <FormHelperText error focused>
                      {errors.deliveryDate && "تاریخ تحویل سفارش الزامی میباشد"}
                    </FormHelperText>
                  </MuiPickersUtilsProvider>
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.deliveryDate &&
                      `${jMoment(props.order.deliveryDate, "YYYY/MM/DD")
                        .locale("fa")
                        .format("jYYYY/jMM/jDD")}`}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"بازه تحویل:  "}</span>

                {editMode ? (
                  <span style={{ flex: 1 }}>
                    <div className={classes.item}>
                      <div style={{ width: "100%" }} data-cy="cutoffId">
                        <Controller
                          rules={{ required: true }}
                          style={{ width: "100%" }}
                          control={control}
                          name="cutoffId"
                          as={
                            <TextField
                              variant="standard"
                              select
                              fullWidth
                              disabled={props.order.deliveryTypeValue === ""}
                              error={!!errors.cutoffId && !!errors.cutoffId}>
                              {listCutoff.map((item) => {
                                return (
                                  <MenuItem value={item.id} id={item.id}>
                                    {item.label}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                          }
                        />
                        <FormHelperText error focused>
                          {errors?.cutoffId &&
                            " بازه تحویل سفارش الزامی میباشد"}
                        </FormHelperText>
                      </div>
                    </div>
                  </span>
                ) : (
                  <span style={{ flex: 1 }}>
                    {`${jMoment(props.order.deliveryStartTime, "HH:mm:ss")
                      .locale("fa")
                      .format("HH:mm")}`}
                    {` - ${jMoment(props.order.deliveryEndTime, "HH:mm:ss")
                      .locale("fa")
                      .format("HH:mm")}`}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"استان:  "}</span>

                {editMode ? (
                  <Controller
                    name="customerProvince"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerProvince"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerProvince
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerProvince)}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"شهر:  "}</span>

                {editMode ? (
                  <Controller
                    name="customerCity"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerCity"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerCity
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerCity)}
                  </span>
                )}
              </div>
            </Grid>
            <Divider className={classes.divider} />

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"نام:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerName"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                    }}
                    as={
                      <TextField
                        name="customerName"
                        variant="standard"
                        defaultValue={props.order.customerName}
                        error={!!errors.customerName && !!errors.customerName}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>{props.order.customerName}</span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"شماره همراه:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerMobileNumber"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                      minLength: 11,
                      maxLength: 11,
                    }}
                    as={
                      <TextField
                        name="customerMobileNumber"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerMobileNumber
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerMobileNumber)}
                  </span>
                )}
              </div>
              <FormHelperText error focused>
                {errors?.customerMobileNumber && "شماره همراه اشتباه است"}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد ملی:  "}</span>
                {editMode ? (
                  <Controller
                    name="customerNationalCode"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                      minLength: 10,
                      maxLength: 10,
                    }}
                    as={
                      <TextField
                        name="customerNationalCode"
                        variant="standard"
                        defaultValue={formaterPhoneNumber(
                          props.order.customerNationalCode
                        )}
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerNationalCode)}
                  </span>
                )}
              </div>
              <FormHelperText error focused>
                {errors?.customerNationalCode && "کد ملی اشتباه است"}
              </FormHelperText>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"آدرس:  "}</span>

                {editMode ? (
                  <Controller
                    name="customerAddress"
                    control={control}
                    rules={{
                      required: !!orderType && orderType !== "TO_CENTER",
                      // minLength: 10,
                    }}
                    as={
                      <TextField
                        name="customerAddress"
                        fullWidth
                        variant="standard"
                        defaultValue={
                          props.order.customerAddress &&
                          props.order.customerAddress
                        }
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {props.order.customerAddress && props.order.customerAddress}
                  </span>
                )}
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"کد پستی:  "}</span>

                {editMode ? (
                  <Controller
                    name="customerZipCode"
                    control={control}
                    as={
                      <TextField
                        defaultValue={props.order.customerZipCode}
                        name="customerZipCode"
                        variant="standard"
                      />
                    }
                  />
                ) : (
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(props.order.customerZipCode)}
                  </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.item}>
                <span className={classes.label}>{"توضیحات:  "}</span>
                <span style={{ flex: 1 }}>
                  {props.order.description && props.order.description}
                </span>
              </div>
            </Grid>
            {props.order.senderName && (
              <Grid item xs={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{"نام فرستنده:"}</span>
                  <span style={{ flex: 1 }}>{props.order.senderName}</span>
                </div>
              </Grid>
            )}
            <Divider className={classes.divider} />
            <Grid item xs={12}>
              <div>
                {editMode ? (
                  <input
                    type="submit"
                    value={"ثبت تغییرات"}
                    className={classes.submitbtn}
                  />
                ) : (
                  <Button
                    fullWidth
                    onClick={() => setEditMode(true)}
                    color="primary"
                    size="medium"
                    variant="contained">
                    تغییر سفارش
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </Card>
      </form>
    </Grid>
  );
}

export default InfoCard;
